/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	ISchemaBuilderArrayModel,
	ISchemaBuilderBooleanModel,
	ISchemaBuilderDataModel,
	ISchemaBuilderEnumModel,
	ISchemaBuilderFloatModel,
	ISchemaBuilderIntegerModel,
	ISchemaBuilderMapModel,
	ISchemaBuilderObjectModel,
	ISchemaBuilderStringModel,
	TGenericModelNode
} from "@adapptio/lib-blueprint";
import { IInspectorControls } from "../InspectorTypes";
import { getInspectorControls } from "./inspectorControls";

type TModel =
	| ISchemaBuilderArrayModel
	| ISchemaBuilderBooleanModel
	| ISchemaBuilderDataModel
	| ISchemaBuilderDataModel
	| ISchemaBuilderEnumModel
	| ISchemaBuilderFloatModel
	| ISchemaBuilderIntegerModel
	| ISchemaBuilderMapModel
	| ISchemaBuilderObjectModel
	| ISchemaBuilderStringModel;

export const ControlSchemaBuilder = (_model: TGenericModelNode): IInspectorControls => {
	const model = _model as TModel;
	return getInspectorControls(model?.props);
};
